/** The type of a hook event. */
export var Type;
(function (Type) {
    Type["ExchangeTokenBy"] = "TriggerHook";
})(Type || (Type = {}));
